"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.QUIZ_PLAYMODES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _Quiz = _interopRequireDefault(require("./Quiz.scss"));

var _QuizModeChooser = _interopRequireDefault(require("./QuizModeChooser.scss"));

var _QuizStrings = require("./QuizStrings");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../../common/components/DataStoreComponent/DataStoreComponent2"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _BuildConstants = require("../../../utils/BuildConstants");

var _PageSlide = _interopRequireDefault(require("../PageSlide/PageSlide"));

var _ExternalWebsite = _interopRequireDefault(require("../ExternalWebsite/ExternalWebsite"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _QuizRoundOverviewStyle = require("./styles/QuizRoundOverviewStyle");

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _QuizPushHelper = _interopRequireDefault(require("./services/QuizPushHelper"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _QuizModeChooserStyle = require("./styles/QuizModeChooserStyle");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _RestService = _interopRequireDefault(require("./services/RestService"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QUIZ_PLAYMODES = {
  SINGLE_PLAYER: 'singlePlayer',
  BATTLE: 'battle'
};
exports.QUIZ_PLAYMODES = QUIZ_PLAYMODES;

var QuizModeChooser = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizModeChooser, _DataStoreComponent);

  var _super = _createSuper(QuizModeChooser);

  function QuizModeChooser(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizModeChooser);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setNavbarTitle", function () {
      var subjects = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS];

      if (subjects && subjects.length > 0) {
        var currentSubject = _this.getCurrentSubject(subjects);

        if (currentSubject && currentSubject.name) {
          _this.props.setTitle(currentSubject.name);
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleMessage", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(pushData) {
        var data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = pushData.detail;
                _context.next = 3;
                return (0, _TimeoutHelper.timeout)();

              case 3:
                (0, _AlertHelper.showAlertWithOptions)({
                  html: data.body,
                  title: data.title,
                  centeredContent: true,
                  size: 'large'
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "displayWaitingMessages", function () {
      var waitingMessages = _QuizPushHelper["default"].getAllWaitingMessages();

      if (waitingMessages.length > 0) {
        var bigMessage = '<div style="text-align:center;">';
        waitingMessages.forEach(function (message) {
          bigMessage += "".concat(message, "<br/><br/>");
        });
        bigMessage += '</div>'; // const okButton = {
        //   label: getString('OK'),
        // }

        setTimeout(function () {
          (0, _AlertHelper.showAlertWithOptions)({
            html: bigMessage,
            title: 'Neue Nachrichten',
            centeredContent: true
          });
        }, 0);

        _QuizPushHelper["default"].resetAllMessages();
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var groupId, feature, userAuth;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              groupId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
              feature = _FeatureManager["default"].getFeature(_config["default"].requiredFeature);

              if (!_config["default"].useDrupalContent) {
                _context2.next = 10;
                break;
              }

              _context2.t1 = "Bearer ";
              _context2.next = 6;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 6:
              _context2.t2 = _context2.sent;
              _context2.t0 = _context2.t1.concat.call(_context2.t1, _context2.t2);
              _context2.next = 11;
              break;

            case 10:
              _context2.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

            case 11:
              userAuth = _context2.t0;
              _context2.next = 14;
              return _UserService["default"].getAllUsersAndLoadTheme(groupId, userAuth);

            case 14:
              _this.setState({
                dataLoaded: true
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "chooseSinglePlayer", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var groupObject;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                dataLoaded: false
              });

              _context3.next = 3;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE, QUIZ_PLAYMODES.SINGLE_PLAYER);

            case 3:
              groupObject = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP);
              groupObject.value = _objectSpread(_objectSpread({}, groupObject.value), groupObject.value.singlePlayer);
              _context3.next = 7;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP, groupObject);

            case 7:
              _context3.next = 9;
              return _UserService["default"].setValuesForGroupObject(groupObject);

            case 9:
              _NavigationManager["default"].goToQuizTraining();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "chooseBattle", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var groupObject, userAuth, storedImages, groupUsersWithImage, loadedUser, opponents, allGamesUnfiltered, allGame, historyBasedFeedback, completedGameIds, expiredGameIds;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                dataLoaded: false
              });

              _context4.next = 3;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE, QUIZ_PLAYMODES.BATTLE);

            case 3:
              groupObject = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP);

              if (!_config["default"].useDrupalContent) {
                _context4.next = 12;
                break;
              }

              _context4.t1 = "Bearer ";
              _context4.next = 8;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 8:
              _context4.t2 = _context4.sent;
              _context4.t0 = _context4.t1.concat.call(_context4.t1, _context4.t2);
              _context4.next = 13;
              break;

            case 12:
              _context4.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

            case 13:
              userAuth = _context4.t0;
              groupObject.value = _objectSpread(_objectSpread({}, groupObject.value), groupObject.value.battle);
              _context4.next = 17;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP, groupObject);

            case 17:
              storedImages = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH);
              _context4.next = 20;
              return _UserService["default"].getUserImages(groupObject.value.users, _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS), userAuth, storedImages);

            case 20:
              groupUsersWithImage = _context4.sent;

              _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

              loadedUser = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);
              opponents = [];
              groupUsersWithImage.forEach(function (groupUser) {
                if (loadedUser && groupUser && groupUser.id === loadedUser.id) {
                  loadedUser.picture = groupUser.picture;

                  _EquizzerActions["default"].setUser(loadedUser, 'QuizSubjects');

                  _EquizzerActions["default"].setUserPoints(groupUser.points);
                } else {
                  opponents.push(groupUser);
                }
              });

              _EquizzerActions["default"].setOpponentsList(opponents);

              _context4.next = 28;
              return _GameService["default"].loadAllGame(userAuth);

            case 28:
              allGamesUnfiltered = _context4.sent;
              _context4.next = 31;
              return _GameService["default"].loadLastGameWithEachOpponent(loadedUser, allGamesUnfiltered);

            case 31:
              allGame = _context4.sent;
              _context4.next = 34;
              return _EquizzerActions["default"].setAllGame(allGame);

            case 34:
              _context4.next = 36;
              return _GameService["default"].loadHistoryBasedFeedback(userAuth);

            case 36:
              historyBasedFeedback = _context4.sent;

              _EquizzerActions["default"].setHistoryBasedFeedback(historyBasedFeedback);

              completedGameIds = _GameService["default"].getCompletedGameIds(allGame);

              _EquizzerActions["default"].updateCompletedGameIds(completedGameIds);

              _context4.next = 42;
              return _GameService["default"].getAllExpiredGames(allGamesUnfiltered);

            case 42:
              expiredGameIds = _context4.sent;

              _EquizzerActions["default"].updateExpiredGameIds(expiredGameIds);

              _EquizzerActions["default"].setShowPresences(Boolean(groupObject.value.showPresence));

              _NavigationManager["default"].goToQuizHome();

            case 46:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getCurrentSubject", function (subjects) {
      if (subjects && subjects.length === 1) {
        return subjects[0];
      } else {
        var subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

        return subjects.find(function (subject) {
          return subject.emsId === subjectId;
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openStatsPage", function () {
      var subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

      var statsUrl = "".concat(_BuildConstants.LEARNING_STATE_HOST, "?quizzer_host=").concat(_BuildConstants.QUIZZER_HOST, "&inApp=1&subject=").concat(subjectId);

      _this.setState({
        learningStateUrl: statsUrl,
        pageIndex: 1
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goBack", function () {
      _this.setState({
        learningStateUrl: null,
        pageIndex: 0
      });
    });
    _this.state = {
      learningStateUrl: null,
      pageIndex: 0,
      dataLoaded: false
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizModeChooser.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_MESSAGES, _DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, _DataStore.DATA_STORE_PATHS.QD_SUBJECTS, _DataStore.DATA_STORE_PATHS.QD_USER_SUBJECTS, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizModeChooser.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'categoryinfos', 'quiz']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(QuizModeChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('quizPushAlert', this.handleMessage);

      if (_config["default"].showQuizGroupNameInNavbar) {
        this.setNavbarTitle();
      } else {
        this.props.setTitle((0, _QuizStrings.getString)('MODE_CHOOSER'));
      }

      if (_DeviceInfoHelper["default"].isOnline()) {
        this.getData();
      } else {
        _DeviceInfoHelper["default"].addOnlineListener(this.getData);
      }

      this.displayWaitingMessages();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID] !== prevState.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID]) {
        console.log('got a new group in mode chooser');
        this.getData();
      }

      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS] !== prevState.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS]) {
        this.setNavbarTitle();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('quizPushAlert', this.handleMessage);

      _DeviceInfoHelper["default"].removeOnlineListener(this.getData);

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizModeChooser.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "renderModeButtons",
    value: function renderModeButtons() {
      var _this2 = this;

      var subjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECTS);

      var isOnline = _DeviceInfoHelper["default"].isOnline();

      if (subjects && subjects.length > 0) {
        var currentSubject = this.getCurrentSubject(subjects);
        var singlePlayerButton = null;
        var battleButton = null;

        if (currentSubject) {
          if (currentSubject && currentSubject.battle && currentSubject.battle.available) {
            battleButton = /*#__PURE__*/_react["default"].createElement(_Image["default"], {
              alt: "battle icon",
              className: _QuizModeChooser["default"].buttonImage,
              src: _config["default"].battleIcon
            });
          }

          if (currentSubject && currentSubject.singlePlayer && currentSubject.singlePlayer.available) {
            singlePlayerButton = /*#__PURE__*/_react["default"].createElement(_Image["default"], {
              alt: "singleplayer icon",
              className: _QuizModeChooser["default"].buttonImage,
              src: _config["default"].singlePlayerIcon
            });
          }
        }

        var dynamicStyles = (0, _QuizModeChooserStyle.getQuizModeChooserStyles)(this.state);

        if (isOnline) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].buttonContainer
          }, battleButton && singlePlayerButton ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].doubleButtonContainer,
            onClick: function onClick() {
              _this2.chooseSinglePlayer();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: dynamicStyles.singlePlayerStyle,
            className: _QuizModeChooser["default"].singlePlayerButton
          }, singlePlayerButton), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, 'Training') : null), _config["default"].showQuizGroupNameInNavbar ? null : /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, currentSubject.name), /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].doubleButtonContainer,
            onClick: function onClick() {
              _this2.chooseBattle();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: dynamicStyles.battleStyle,
            className: _QuizModeChooser["default"].battleButton
          }, battleButton), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, 'Wettbewerb') : null)) : null, battleButton && !singlePlayerButton && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _config["default"].showQuizGroupNameInNavbar ? null : /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, currentSubject.name), /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].singleButtonContainer,
            onClick: function onClick() {
              _this2.chooseBattle();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: dynamicStyles.battleStyle,
            className: _QuizModeChooser["default"].battleButton
          }, battleButton), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, 'Wettbewerb') : null)), !battleButton && singlePlayerButton && /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].singleButtonContainer,
            onClick: function onClick() {
              _this2.chooseSinglePlayer();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: dynamicStyles.singlePlayerStyle,
            className: _QuizModeChooser["default"].singlePlayerButton
          }, singlePlayerButton), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, 'Training') : null));
        } else {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].buttonContainer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].singleButtonContainer,
            onClick: function onClick() {
              _this2.chooseSinglePlayer();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: dynamicStyles.singlePlayerStyle,
            className: _QuizModeChooser["default"].singlePlayerButton
          }, singlePlayerButton), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizModeChooser["default"].subjectName
          }, 'Training') : null));
        }
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var buttons = this.renderModeButtons();
      /*
      if (!DeviceInfoHelper.isOnline()) {
        return (
          <div>Bitte gehen Sie online um spielen zu können</div>
        )
      }
        */

      if (!this.state.dataLoaded && _DeviceInfoHelper["default"].isOnline()) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var dynamicStyles = (0, _QuizModeChooserStyle.getQuizModeChooserStyles)(this.state);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].contentHome
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_PageSlide["default"], {
        index: this.state.pageIndex,
        showNavbar: true,
        showBottomBar: false
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, buttons, _DeviceInfoHelper["default"].isOnline() && /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizModeChooser["default"].statsContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: dynamicStyles.statsStyle,
        className: _QuizModeChooser["default"].statsIconContainer
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: _config["default"].statsIcon,
        onClick: function onClick() {
          return _this3.openStatsPage();
        },
        className: _QuizModeChooser["default"].statsIcon
      })), _config["default"].showQuizModeNames ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizModeChooser["default"].subjectName
      }, 'Lernstand') : null)), _DeviceInfoHelper["default"].isOnline() && /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizModeChooser["default"].externalSite
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizModeChooser["default"].backButton,
        style: dynamicStyles.backButtonStyle,
        onClick: this.goBack
      }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], {
        style: {
          fontSize: '25px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _QuizModeChooser["default"].backText
      }, (0, _QuizStrings.getString)('BACK'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizModeChooser["default"].iframeContainer
      }, /*#__PURE__*/_react["default"].createElement(_ExternalWebsite["default"], {
        setTitle: this.props.setTitle,
        hidden: this.state.pageIndex === 0,
        externalWebsiteSendsMessages: true,
        url: this.state.learningStateUrl
      }))))));
    }
  }]);
  return QuizModeChooser;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizModeChooser;
QuizModeChooser.propTypes = {
  onBack: _propTypes["default"].func,
  setTitle: _propTypes["default"].func,
  tournamentMode: _propTypes["default"].bool,
  runsInKesi: _propTypes["default"].bool,
  trainingMode: _propTypes["default"].bool,
  hideLearningState: _propTypes["default"].bool,
  changePageToQuizHome: _propTypes["default"].func,
  setAblyAsRegistered: _propTypes["default"].func.isRequired
};